import { posthog } from '@/lib/posthog'

export type AuthMethod = 'google' | 'apple' | 'line' | 'email' | 'google_onetap'
export type AuthSurface = 'login' | 'signup' | 'modal' | 'sheet'

const KEY = 'authPendingMethod'
const PENDING_TTL_MS = 60 * 60_000
const NEW_USER_WINDOW_MS = 10 * 60_000

export const isNewUser = (createdAt: number | undefined, now = Date.now()) =>
  typeof createdAt === 'number' && now - createdAt < NEW_USER_WINDOW_MS

export function trackAuthScreen(surface: AuthSurface) {
  posthog.capture('auth_screen_viewed', { surface, platform: 'web' })
}

// Persisted in localStorage (not sessionStorage) because a magic link finishes
// in a fresh tab. The method is read back once a session exists.
export function trackAuthMethod(method: AuthMethod, surface: AuthSurface) {
  posthog.capture('auth_method_selected', {
    method,
    mode: surface === 'login' ? 'signin' : 'signup',
  })
  try {
    localStorage.setItem(KEY, JSON.stringify({ method, at: Date.now() }))
  } catch {
    // private mode: auth_completed just won't fire
  }
}

export function takePendingAuthMethod(): AuthMethod | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    localStorage.removeItem(KEY)
    const { method, at } = JSON.parse(raw) as { method: AuthMethod; at: number }
    return Date.now() - at < PENDING_TTL_MS ? method : null
  } catch {
    return null
  }
}
